import type {AuditDataAssetsFilesBody} from './AuditDataAssetsFilesBody';

export type AuditDataAssetsBody = {
  paramDefinitionId: string;
  files: AuditDataAssetsFilesBody[];
};
